/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { JobsControllerCreateMutationRequest, JobsControllerCreateMutationResponse, JobsControllerCreate400, JobsControllerCreate401, JobsControllerCreate403, JobsControllerCreate404 } from "../../models/jobsController/JobsControllerCreate";

function getJobsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/jobs` as const }  
  return res
}

/**
 * @description Create a single job or batch of jobs with dependencies. For batch creation, use refIds to define dependencies between jobs in the same batch.
 * @summary Create one or more jobs
 * {@link /api/v1/jobs}
 */
export async function jobsControllerCreate(data?: JobsControllerCreateMutationRequest, config: Partial<RequestConfig<JobsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<JobsControllerCreateMutationResponse, ResponseErrorConfig<JobsControllerCreate400 | JobsControllerCreate401 | JobsControllerCreate403 | JobsControllerCreate404>, JobsControllerCreateMutationRequest>({ method : "POST", url : getJobsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}